
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { formatArrivalDate } from '../../../utils/Functions';
import { ItineraryService } from '../../../shared/itinerary.service';
import {Router, NavigationExtras} from "@angular/router";
import { CookieService } from 'ngx-cookie';
import { RestService } from '../../../shared/rest.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../../../pages/com.usblick.common/auth/user.service';
import { MatDialog } from '@angular/material/dialog';
import { FidelityService } from '../../../fidelity/fidelity.service';
import { ApiService } from '../../../itinerary/shared/api.service';
import { setting } from '../../../../../setting';
import * as moment from 'moment';
import { DynamicFontSizePipe } from 'app/shared/dynamic-font-size.pipe';
import CssFilterConverter from 'css-filter-converter';

interface IItemItinerary {
  date: Date;
  position: number;
  checkout: boolean;
}
@Component({
  selector: 'usb-yourtrip-summary',
  templateUrl: './yourtrip-summary.component.html',
  styleUrls: ['./yourtrip-summary.component.scss'],
  providers: [
    DynamicFontSizePipe
  ]
})
export class YourtripSummaryComponent implements OnInit {

  @Input() actualItinerary: any;
  @Input() qtyItemsToPartial: number;
  @Input() appLoading: boolean;
  @ViewChildren('icons', { read: ElementRef }) icons : QueryList<ElementRef>;

  formatDate = formatArrivalDate;
  flyQty: string;
  nameItinerary: string;
  arrival: string;
  departure: string;
  totalPrice: number;
  destinySecuency: string;
  nigths: number = 0;
  adults: number = 0;
  children: number = 0;
  products: any;
  partialReserve: boolean = false;
  _cookieClient: any = undefined;
  status: string;
  continueToReserve:boolean = false;
  enablePartialReserve:boolean = false;
  public getClientsSettingAppBooking: any;
  nightsTotalDiff:number = 0;
  getOrigin:string = '';

  fontSizeAdjustments = { 4: 0, 6: -2, 9: -6 }; // Define los ajustes en el componente
    tooltipFlight: boolean = false;


  totalNetPriceBooking = 0;
  totalBlickoins = 0;
  daysValue = 0;
  nightValue = 0;
  arrivalDateValue:string;
  departureDateValue:string;
  public totalAdults: number;
  public totalChildren: number;

  totalTaxPrice: number = 0;
  totalNetPriceBookingFreeTax: number = 0;
  optionNightsNetTotalProf: number = 0;
  currencyItinerary: string;
  qtyNights:number = 0;
  qtyDays:number = 0;
  totalProviderTransports:number = 0;
  timeArrive:string = '';
  timeDropoff:string = '';
  colorFlight: string;
  flightsInternal: any[] = [];

  public items: any[] = [];
  private _lastFlights: any[] = [];
  private _cachedResult: any[] = [];

  constructor(
    private itineraryService: ItineraryService,
    private router: Router,
    public vcr: ViewContainerRef,
    private _cookieService: CookieService,
//
    private spinner: NgxSpinnerService,
    private restService: RestService,
    public userService:UserService,
    private dialog:MatDialog,
    public fidelityService:FidelityService,
    private apiService:ApiService,
    )
    {
      this.status = 'false';
      //this.toastr.setRootViewContainerRef(this.vcr);
      this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));

    }

  ngOnInit() {
    this.colorFlight = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
    this.getOrigin = localStorage.getItem('origin');

    this.initComponent();
    this._loadCheckout();

    this.getTimeArrive();


    // console.log('actualItinerary items ->', this.actualItinerary.items);



    let suscription = this.itineraryService.getItinerary$();
    suscription.subscribe((data:any) => {
      if (data) {
        this.actualItinerary = data[0];
        if (this.actualItinerary) {
          this.totalNetPriceBooking =  this.actualItinerary.totalNetPriceBooking;
          this.totalBlickoins =  this.actualItinerary.totalBlickoins;
          this.totalTaxPrice = this.actualItinerary.totalTaxPrice;
          this.optionNightsNetTotalProf = this.actualItinerary.optionNightsNetTotalProf;
          this.totalNetPriceBookingFreeTax = this.actualItinerary.totalNetPriceBookingFreeTax;
          this.currencyItinerary = this.actualItinerary.currency;
        }
        this._loadCheckout();
      }

    });
    this.totalNetPriceBooking =  this.actualItinerary.totalNetPriceBooking;
    this.totalBlickoins =  this.actualItinerary.totalBlickoins;
    this.totalTaxPrice = this.actualItinerary.totalTaxPrice;
    this.totalNetPriceBookingFreeTax = this.actualItinerary.totalNetPriceBookingFreeTax;
    this.totalProviderTransports = this.actualItinerary.totalNetPriceCategory
    this.currencyItinerary = this.actualItinerary.currency;
    // this.getDaysDif();
    const passengerData = this.restService.getPassengersData();
    let booleanTimer = this.restService.getBooleanTimer();


    this.getDaysAndNights();
    this.getFlyItinerariesInternal();
  }

   /**
   * construye un array de formato IItemItinerary con:
   * checkout false con arrivalDate.
   * checkout true con departureDate.
   * Luego se ordena el array en base a la fecha y por ultimo
   * crea un nuevo objeto con el orden correcto, y el flag checkout.
   * @private
   */
   private _loadCheckout() {

    this.items = [];


    if(this.actualItinerary !== undefined && this.actualItinerary.length > 0) {

      this.items = (<IItemItinerary[]>[
        ...this.actualItinerary.items.map((x, i) => (
          {
            date: new Date(x.arrivalDate),
            position: i,
            checkout: false
          }
        )),
        ...this.actualItinerary.items.map((x, i) => ({ date: new Date(x.departureDate), position: i, checkout: true }))
      ]).sort((a, b) => a.date.valueOf() - b.date.valueOf())
        .map(x => ({ ...this.actualItinerary.items[x.position], ckeckout: x.checkout }));

    }

    // console.log(this.actualItinerary)

    if (this.actualItinerary && this.actualItinerary.items && Array.isArray(this.actualItinerary.items)) {
      // Calcula la suma de paxAdults y paxChildren
      this.totalAdults = this.actualItinerary.items.reduce((sum, item) => sum + (item.paxAdults || 0), 0);
      this.totalChildren = this.actualItinerary.items.reduce((sum, item) => sum + (item.paxChildren || 0), 0);
    }
  }


    goToReserve(onlySaveDraft: boolean = false){
    this.appLoading = true;
    //validar client owner
    let invalidOwner = false;

    this._cookieClient = (this._cookieService.get('clientActive') != undefined) ?  this._cookieService.get('clientActive') : undefined;

    if (this._cookieClient !== undefined) {
      let data = this._cookieClient.split("||");
      if(data[2].trim()=='' || data[2].trim()=='false' || data[4].trim()=='' || data[3].trim()==''){
        invalidOwner = true;
        //this.toastr.warning('Please complete all information for owner!');
      }
    } else {
      invalidOwner = true;
      //this.toastr.warning('Please complete all information for owner!');
    }


    if (!invalidOwner) {

      this.goToItinerary(); // Llama al la vista de Fee

    }
  }


  goToItinerary() {

    // this.spinner.show();
    setTimeout(() => { this.appLoading = false; }, 1999);


    setTimeout(() => {

      if(this.partialReserve && this.qtyItemsToPartial>0){


        const navigationExtras: NavigationExtras = {
          queryParams: {
            'id': this.actualItinerary.id,
            'stat': this.status,
            'screen': 'addFee',
            'goTo' : 'partialReserve',
          }
        };

        this.router.navigate(['/itinerary-detail'], navigationExtras);

      }else{


        const navigationExtras: NavigationExtras = {
          // queryParams: {
          //   'id': this.actualItinerary.id,
          //   'stat': this.status,
          //   'screen': 'addFee',
          //   'goTo' : 'reserve',
          // }
          queryParams: {
            'id': this.actualItinerary.id,
            'stat': this.status,
            'screen': 'detail',
            'goTo' : 'reserve',
          }
        };
        this.router.navigate(['/itinerary-detail'], navigationExtras);

      }

    }, 2000);

  }


  initComponent() {
    if (this.actualItinerary) {
      this.nameItinerary = this.actualItinerary.title;
      let arrivalDates = [];
      let departureDates = [];
      let origin: string;

      if(this.actualItinerary.items.length > 1){
        this.enablePartialReserve = true;
      }

      this.actualItinerary.items.forEach(date => {

        if(date.status_id == 1){
          this.continueToReserve=false;
        }

        arrivalDates.push(date.arrivalDate);
        departureDates.push(date.departureDate);
        if (date.categoryName === 'INSURANCE') {
          origin = date.origin;
        }
      });

      arrivalDates.sort();
      departureDates.sort().reverse();

      this.arrival = this.actualItinerary.arrivalDate ;
      this.departure = this.actualItinerary.departureDate;
      this.destinySecuency = this.getDestinySecuency(this.actualItinerary.destination, origin);
      this.getQtyPax(this.actualItinerary.items);
      // this.totalPrice = this.getTotalPrice(this.actualItinerary.items);
      this.totalPrice = this.actualItinerary.totalPrice;


      let suscription = this.itineraryService.getItinerary$();
      suscription.subscribe((data:any) => {
        if (data && Object.keys(data).length > 0) {
          this.actualItinerary = data[0];
          this.destinySecuency = this.getDestinySecuency(this.actualItinerary.destination, origin);
          this.getQtyPax(this.actualItinerary.items);
        }
      });

    }

  }

onUpdateFly(event: boolean): void {
  // The flight-modal component handles API calls internally.
  // The itinerary updates via the getItinerary$() subscription in ngOnInit.
}

getQtyPax(items: any[]): void {
  if (items.length === 0) {
    return;
  }

  let maxAdults = 0;
  let maxChildrens = 0;

    // ✅ Obtener edades CON su fecha de llegada
  const childrenWithDates = this.getChildrenAgesWithDate(items);

  items.forEach(item => {
    const adultsNum = Number(item.paxAdults);
    const childrensNum = Number(item.paxChildren);

    if (adultsNum > maxAdults) {
      maxAdults = adultsNum;
    }

    if (childrensNum > maxChildrens) {
      maxChildrens = childrensNum;

    }
  });

  this.adults = maxAdults;
  this.children = childrenWithDates.length;

}

/**
 * Obtiene todas las edades de niños con su fecha de llegada correspondiente
 * @param items - Lista de items del itinerario
 * @returns Array de objetos con edad y arrivalDate
 */
getChildrenAgesWithDate(items: any): { age: number, arrivalDate: Date, arrivalDateString: string}[] {
  const result: { age: number, arrivalDate: Date, arrivalDateString: string }[] = [];

  for (const item of items) {

    const currentDateStr = new Date().toISOString().split('T')[0];
    const categoryId = item.category_id;
    let payloadUpdate;
    // ✅ Normalizar la fecha correctamente
    let arrivalDate: Date | null = null;

    if (item.arrivalDate) {
      arrivalDate = this.normalizeDate(currentDateStr);

    }

    if (item.dateIni) {
      arrivalDate = this.normalizeDate(item.dateIni);

    }

    if (!arrivalDate) {
      console.warn(`Item ${item.id} sin fecha de llegada`);
      continue;
    }

    if (!arrivalDate) {
      console.warn(`Item ${item.id} sin fecha de llegada`);
      continue;
    }

    if (item.category_id === 8) {
      payloadUpdate = item.payloadSync;
    } else {
      payloadUpdate = item.payloadUpdate;
    }

    if (!payloadUpdate || !payloadUpdate.products || payloadUpdate.products.length === 0) {
      continue;
    }

    let ages: number[] = [];
    switch (categoryId) {
      case 1: // HOTELES
        const roomConfigurations = payloadUpdate.products[0]?.others?.hotels?.roomConfiguration;
        if (roomConfigurations && Array.isArray(roomConfigurations)) {
          for (const room of roomConfigurations) {
            if (room.children && Array.isArray(room.children)) {
              ages.push(...room.children.map((age: any) => Number(age)));
            }
          }
        }
        break;

      case 2: // RENT A CAR
        const rentAcarChildren = payloadUpdate.childAge;
        if (rentAcarChildren && Array.isArray(rentAcarChildren)) {
          ages = rentAcarChildren.map((age: any) => Number(age));
        }
        break;

      case 6: // TOURS / EXPERIENCIAS
        const tourChildren = payloadUpdate.products[0]?.others?.tours?.children;
        if (tourChildren && Array.isArray(tourChildren)) {
          ages = tourChildren.map((age: any) => Number(age));
        }
        break;

      case 8: // TRANSPORTS / TRASLADOS
        const transferChildren = payloadUpdate.products[0]?.others?.transfers?.paxList?.children;
        if (transferChildren && Array.isArray(transferChildren)) {
          ages = transferChildren.map((age: any) => Number(age));
        }
        break;

      case 9: // TICKETS
        const ticketChildren = payloadUpdate.products[0]?.others?.tours?.children;
        if (ticketChildren && Array.isArray(ticketChildren)) {
          ages = ticketChildren.map((age: any) => Number(age));
        }
        break;

      case 10: // ASISTENCIA / PAQUETES
        const assistanceChildren = payloadUpdate.products[0]?.insurances?.paxList?.paxAges?.filter((c: any) => c < 18) || [];
        if (assistanceChildren && Array.isArray(assistanceChildren)) {
          ages = assistanceChildren.map((age: any) => Number(age));
        }
        break;
    }
    // Agregar cada edad con su arrivalDate correspondiente
    for (const age of ages) {
      result.push({
        age: age,
        arrivalDate: arrivalDate,
        arrivalDateString : currentDateStr
      });
    }

  }

  return result;
}

private normalizeDate(dateStr: string, subtractOneDay: boolean = true): Date | null {

  if (!dateStr) return null;

  const parts = dateStr.split('T')[0].split('-');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);

  let date = new Date(Date.UTC(year, month, day, 12, 0, 0));

  if (subtractOneDay) {
    date.setUTCDate(date.getUTCDate() - 1);
  }

  return date;
}


  getFlyItinerariesInternal(): void {
    if(this.actualItinerary.flights && this.actualItinerary.flights.length > 0) {
       const dataCopy = [...this.actualItinerary.flights];
       const firstFlight = dataCopy.shift(); // Remueve el primer elemento

       this.flightsInternal = dataCopy;

    }
  }

  /**
   * get string secuency destinys
   * @param destinys
   */
  getDestinySecuency(destinys: Array<any>, origin?: string): string {
    let secuency = '';
    this.nigths = 0;
    this.adults = 0;
    this.children = 0;
    if (origin) {
      if (destinys.length === 1) {
        secuency = origin + ' > ' + destinys[0].iata_code;
      } else {
        secuency = origin;
      }
    }
    if (destinys) {
      for (let i = 0; i < destinys.length; i++) {
        let depar1 = new Date(destinys[i].destination_info.departure);
        let depar2 = new Date(this.departure);
        this.nigths += parseInt(destinys[i].destination_info.nights);
        if (!origin && i === 0) {
          secuency = secuency.concat((destinys[i] && destinys[i].destination_info.cityName) ?
            destinys[i].destination_info.cityName : '');
        } else if (destinys[i] && destinys[i].destination_info.cityName) {
          if(destinys[i].destination_info.cityName !== ''){
            secuency = secuency.concat(' > ' + destinys[i].destination_info.cityName);
          }
        }
      }
    }
    return secuency;
  }


  existHotel(){
    if(this.userService.itineraryActive.length > 0){
      if(this.userService.itineraryActive[0].items.length>0){
        let exist = this.userService.itineraryActive[0].items.find( element => element.categoryName == "HOTELS" );

        if(exist){
          return true;
        }else{
          return false;
        }
      }
    }
  }


   getDaysAndNights():void{
    this.qtyNights = this.actualItinerary.nights;
    this.qtyDays = this.actualItinerary.nights + 1;

    // console.log('qtyNights', this.qtyNights);

   }

   getHourFly(dateTime: any): string {
      if (dateTime) {
        return dateTime.slice(11, 16); // 'HH:MM' empieza en el índice 11
      }
      return '';
   }

   afterDateFlyOut(dateFlyIn: string, dateFlyOut: string): string {
    const inDate = new Date(dateFlyIn);
    const outDate = new Date(dateFlyOut);

    // Diferencia en milisegundos
    const diffTime = outDate.getTime() - inDate.getTime();

    // Convertimos la diferencia a días, horas y minutos
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));

    if (diffDays > 0) {
        return `(+${diffDays} día${diffDays > 1 ? 's' : ''})`;
    } else {
        return `(+${diffHours}:${diffMinutes.toString().padStart(2, '0')} hs.)`;
    }
}

/**
 * Renderiza la hora del traslado.
 */
getTimeArrive():void{
  const initArrive = this.userService.itineraryActive[0].items;
  let pickupTime:string;
  let dropoffTime:string;

  initArrive.forEach((arrive:any) => {
    if(arrive.categoryName === 'TRANSPORTS'){
      pickupTime = arrive.payload[0].transfers.pickupTime;
      dropoffTime = arrive.payload[0].transfers.dropoffTime;
      }
    });

  this.timeArrive = pickupTime != null ? `- ${pickupTime} hs` : '';
  this.timeDropoff = dropoffTime != null ? `- ${dropoffTime} hs` : '';

}

/**
 * Controla la visibilidad del tooltip de vuelo y aplica filtros de color cuando se muestra
 *
 * Este método gestiona el estado de visualización del tooltip y cuando se activa (event = true),
 * aplica filtros CSS personalizados a los íconos basados en el color configurado para vuelos.
 *
 * @param {boolean} event - Estado de visibilidad del tooltip (true = visible, false = oculto)
 * @returns {void}
 *
 * @actions
 * - Actualiza el estado de tooltipFlight
 * - Cuando se muestra (event = true), ejecuta applyImageFilter()
 *
 * @sideEffects
 * - Modifica tooltipFlight con el nuevo estado
 * - Ejecuta applyImageFilter() que modifica estilos CSS de íconos
 *
 * @example
 * // Mostrar tooltip y aplicar filtros:
 * this.changeTooltipFlightVisible(true);
 *
 * // Ocultar tooltip:
 * this.changeTooltipFlightVisible(false);
 */
changeTooltipFlightVisible(event: boolean): void {
  if(event) {
     this.applyImageFilter();
  }

  this.tooltipFlight = event;
}

  /**
 * Aplica filtros CSS personalizados a íconos basados en el color de vuelo configurado
 *
 * Este método convierte un color hexadecimal a filtros CSS equivalentes y los aplica
 * a los íconos de vuelo, específicamente al primero y último ícono de la lista.
 *
 * @returns {void}
 *
 * @process
 * 1. Convierte hex color a filtros CSS usando CssFilterConverter
 * 2. Extrae y formatea los filtros de color
 * 3. Aplica los filtros a los íconos con setTimeout para evitar conflictos de renderizado
 *
 * @uses CssFilterConverter.hexToFilter() - Conversor de hex a filtros CSS
 * @uses setTimeout(0) - Para aplicar estilos después del ciclo de renderizado actual
 *
 * @targetElements
 * - Primer ícono (index = 0)
 * - Último ícono (index = icons.length - 1)
 *
 * @styling
 * - filter: Aplica los filtros de color convertidos
 * - width: 40px - Establece ancho fijo para los íconos
 *
 * @dependencies
 * - Requiere this.colorFlight configurado con color hexadecimal
 * - Requiere this.icons con referencias a elementos DOM
 */
    applyImageFilter() {
      const color = this.colorFlight;
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

      //Extraemos el literal en String de la conversión
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

      // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";

      const filter = colorFilter;

      // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
      setTimeout(() => {

        this.icons.forEach(((icon, index) => {
          if(index === 0 || index === this.icons.length - 1) {
            icon.nativeElement.setAttribute('style', `filter: ${filter}; width: 40px;`);
          }
        }));
      }, 0);
    }


getActualFlyInternal(flights: any[], value: string): any {
  if (!flights || flights.length < 1) {
    return null;
  }

  // Descartar primer y último elemento
  const middleFlights = flights;
  const currentDate = new Date();

  // 1. Buscar vuelo actual (en curso)
  const currentFlight = middleFlights.find(flight => {
    try {
      if (!flight?.departureOut || !flight?.arrivalOut) return false;

      const departure = new Date(flight.departureOut);
      const arrival = new Date(flight.arrivalOut);

      return currentDate >= departure && currentDate <= arrival;
    } catch (error) {
      console.error('Error procesando vuelo:', flight, error);
      return false;
    }
  });

  if (currentFlight && currentFlight[value]) {
    return currentFlight[value];
  }

  // 2. Si no hay vuelo actual, buscar próximo vuelo
  const nextFlight = middleFlights
    .filter(flight => flight?.departureOut)
    .sort((a, b) => new Date(a.departureOut).getTime() - new Date(b.departureOut).getTime())
    .find(flight => new Date(flight.departureOut) > currentDate);

  return nextFlight ? nextFlight[value] : null;
}



getDataTooltip(fly: any, index: number, value: string): string {
  const position = this.getPosition(index);
  return this.getDataFlyValue(fly, value, position);
}

private getPosition(index: number): 'first' | 'middle' | 'last' {
  const lastIndex = this.getFlyArr(this.actualItinerary?.flights).length - 1;

  if (index === 0) return 'first';
  if (index === lastIndex) return 'last';
  return 'middle';
}

private getDataFlyValue(fly: any, value: string, position: 'first' | 'middle' | 'last'): string {
  const valueMap = {
    iata: {
      first: () => fly.airportIataCodeIn,
      middle: () => fly.iataCityArrivalOut,
      last: () => fly.airportIataCodeOut
    },
    date: {
      first: () => fly.arrivalIn,
      middle: () => fly.arrivalOut,
      last: () => fly.departureOut
    }
  };

  return valueMap[value]?.[position]?.() || '';
}


getFlyArr(flights: any[]): any[] {

  if (!flights || flights.length === 0) return [];

  // Verificar si los flights han cambiado
  const hasChanged = this.hasFlightsChanged(flights);

  if (!hasChanged && this._cachedResult.length > 0) {
    return this._cachedResult;
  }

  // Calcular nuevo resultado: todos los vuelos originales + primer vuelo al final
  const result = [...flights]; // Copiar todos los vuelos originales

  // Agregar el PRIMER vuelo otra vez como "último" elemento
  if (flights[0]) {
    result.push(flights[0]);
  }

  // Actualizar cache
  this._lastFlights = [...flights];
  this._cachedResult = result;

  return result;
}

private hasFlightsChanged(newFlights: any[]): boolean {
  if (this._lastFlights.length !== newFlights.length) return true;

  for (let i = 0; i < newFlights.length; i++) {
    if (this._lastFlights[i]?.id !== newFlights[i]?.id) {
      return true;
    }
  }

  return false;
}

}
